module.exports = __webpack_public_path__ + "images/psp/Dirt-Bike/dirtbike.webp";